module.exports = __webpack_public_path__ + "img/intesarbm-logo.d132ec7d.png";